"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeNode = void 0;
const filter_1 = require("../nodes/filter");
const grain_suppressor_1 = require("../nodes/grain-suppressor");
const join_1 = require("../nodes/join");
const sort_1 = require("../nodes/sort");
const table_input_1 = require("../nodes/table-input");
const node_1 = require("../node");
const error_1 = require("../../error");
const page_1 = require("../nodes/page");
const grain_filter_1 = require("../nodes/grain-filter");
const calculated_field_1 = require("../nodes/calculated-field");
const aggregate_1 = require("../nodes/aggregate");
const count_1 = require("../nodes/count");
const count_distinct_1 = require("../nodes/count-distinct");
const distinct_1 = require("../nodes/distinct");
const filter_group_1 = require("../nodes/filter-group");
const pophealth_1 = require("../nodes/specialty/pophealth");
function deserializeNode(obj) {
    let nodeClasses = [
        calculated_field_1.default, filter_1.default, grain_filter_1.default, grain_suppressor_1.default, join_1.default, sort_1.default, table_input_1.default,
        page_1.default, aggregate_1.default, count_1.default, count_distinct_1.default, distinct_1.default, filter_group_1.default,
        pophealth_1.default, node_1.V1QuantumGraph,
    ];
    let node;
    for (let nodeClass of nodeClasses) {
        node = nodeClass.from(obj);
        if (node)
            break;
    }
    if (!node)
        throw new error_1.default('Cannot deserialize node: Invalid object');
    if (obj['id']) {
        if (!obj['id'].match(/^[a-z][a-z0-9-_]*$/i))
            throw new error_1.default('Invalid node id: ' + obj['id']);
        node.id = obj['id'];
    }
    obj['incoming']
        .map(deserializeNode)
        .forEach((inNode, i) => inNode.connect(node, i));
    return node;
}
exports.deserializeNode = deserializeNode;
function deserializeV1(obj) {
    let graph = node_1.V1QuantumGraph.from(obj);
    if (!graph)
        throw new error_1.default('Cannot deserialize quantum graph: Invalid object');
    if (obj['id'])
        graph.id = obj['id'];
    deserializeNode(obj['incoming'][0]).connect(graph);
    return graph;
}
exports.default = deserializeV1;
